import * as types from './mutation-types';

export const closeTopInfo = function ({commit}) {

    commit( types.CLOSETOPINFO );
    commit( types.OPENWILLSHOW );

};

export const topInfoToggle = function ({commit, state}, {type, msgIndex, timeout}) {

    commit( types.SETTOPINFO, {type, msgIndex});

    state.topInfo.timeOut && clearTimeout( state.topInfo.timeOut );

    state.topInfo.timeOut = setTimeout(() => {
        
        commit( types.CLOSETOPINFO );

    }, timeout );

};



// WEBPACK FOOTER //
// ./src/store/actions.js